import React from 'react'

import { Switch, Route } from 'react-router-dom'
import SalesTeamPlansRoutes from './routes'
import UnderMaintenancePage from '../UnderMaintenance/UnderMaintenancePage'

const SalesTeamPlansPage: React.FC = () => {
  return (
    <Switch>
      <Route path={SalesTeamPlansRoutes.List}>
        <UnderMaintenancePage />
      </Route>
    </Switch>
  )
}

export default SalesTeamPlansPage
